
      const umamiScriptUrl = ''.trim()
      const umamiWebsiteId = ''.trim()

      if (umamiScriptUrl && umamiWebsiteId) {
        const script = document.createElement('script')
        script.defer = true
        script.src = umamiScriptUrl
        script.dataset.websiteId = umamiWebsiteId
        document.head.appendChild(script)
      }
    